import dayjs from "dayjs";
import { makeAutoObservable } from "mobx";

type ParamsPlanning2DatesStore = {
  reversed?: boolean;
  initialBegin?: string;
  initialEnd?: string;
};

export class Planning2DatesStore {
  constructor({
    reversed,
    initialBegin,
    initialEnd,
  }: ParamsPlanning2DatesStore = {}) {
    this.reversed = !!reversed;
    this.initialBegin = initialBegin ?? "";
    this.initialEnd = initialEnd ?? "";
    makeAutoObservable(this);
  }

  readonly reversed: boolean;

  initialBegin: string;

  initialEnd: string;

  setInitialDates(
    begin: string | null | undefined,
    end: string | null | undefined,
  ) {
    this.initialBegin = begin ?? "";
    this.initialEnd = end ?? "";
  }

  begin: string = "";

  setBegin(value: string | null | undefined) {
    this.begin = value ?? "";
  }

  end: string = "";

  setEnd(value: string | null | undefined) {
    this.end = value ?? "";
  }

  get duration(): string {
    // Это сделано потому что сейчас продолжительность не приходит с бэка
    // end = начало + длительность − 1.
    // => duration = end - begin + 1;

    const { initialBegin, initialEnd } = this;
    if (!initialBegin || !initialEnd) return "";
    const beginDate = dayjs(initialBegin);
    const endDate = dayjs(initialEnd);
    if (!beginDate.isValid() || !endDate.isValid()) return "";
    return String(endDate.diff(beginDate, "days") + 1);
  }

  get disabledBegin(): boolean {
    return this.reversed;
  }

  get disabledEnd(): boolean {
    return !this.reversed;
  }
}
